import { Building2, Network } from 'lucide-react';
import { Input } from './ui/input';
import { Label } from './ui/label';

const OPTIONS = [
  { key: 'single', label: 'One pharmacy', note: 'A single location', icon: Building2 },
  { key: 'chain', label: 'A chain of branches', note: 'One owner account for every location', icon: Network },
];

export const ChainChoice = ({ value, onChange }) => {
  const isChain = value > 1;
  return (
    <div className="space-y-3" data-testid="signup-chain-choice">
      <Label>How many locations do you run?</Label>
      <div className="grid gap-3 sm:grid-cols-2">
        {OPTIONS.map(({ key, label, note, icon: Icon }) => {
          const active = (key === 'chain') === isChain;
          return (
            <button type="button" key={key} onClick={() => onChange(key === 'chain' ? Math.max(2, value) : 1)}
              className={`flex items-start gap-3 border p-4 text-left transition-colors ${active ? 'border-emerald-400 bg-emerald-400/10' : 'border-white/10 bg-black/10 hover:border-white/25'}`}
              data-testid={`signup-chain-option-${key}`}>
              <Icon size={18} className="mt-0.5 shrink-0 text-emerald-300" />
              <span><strong className="block text-sm">{label}</strong><span className="block text-xs text-slate-400">{note}</span></span>
            </button>
          );
        })}
      </div>
      {isChain && (
        <div className="flex flex-wrap items-center gap-3 border-l-2 border-emerald-400 bg-emerald-400/5 p-3" data-testid="signup-chain-count-block">
          <Label htmlFor="signup-chain-count" className="text-sm">Total locations, including this one</Label>
          <Input id="signup-chain-count" type="number" min={2} max={50} value={value} className="w-24"
            onChange={(e) => onChange(Math.min(50, Math.max(2, parseInt(e.target.value, 10) || 2)))}
            data-testid="signup-chain-count-input" />
          <p className="w-full text-xs text-slate-400">You'll set up this pharmacy as your head location now, then add the other branches right after signup.</p>
        </div>
      )}
    </div>
  );
};

export const ChainBillSummary = ({ locations, plan, planName, slotPrice, cycle }) => {
  const covered = plan?.branches ?? 1;
  const extra = Math.max(0, locations - covered);
  const annual = cycle === 'annual';
  const base = annual ? Math.round((plan?.annual ?? 0) / 12) : (plan?.monthly ?? 0);
  const slot = annual ? Math.round(slotPrice * 0.8) : slotPrice;
  const total = base + extra * slot;
  return (
    <div className="border border-emerald-400/30 bg-emerald-400/5 p-4 text-sm" data-testid="signup-chain-bill-summary">
      <p className="font-semibold text-emerald-200">One subscription for all {locations} locations</p>
      <ul className="mt-2 space-y-1 text-slate-300">
        <li data-testid="signup-chain-bill-covered">{planName} covers {covered} location{covered === 1 ? '' : 's'} · GHS {base.toLocaleString()}/month</li>
        {extra > 0 && <li data-testid="signup-chain-bill-extra">{extra} extra location{extra === 1 ? '' : 's'} × GHS {slot}/month</li>}
      </ul>
      <p className="mt-2 font-semibold text-white" data-testid="signup-chain-bill-total">About GHS {total.toLocaleString()} a month{annual ? ', billed yearly' : ''} once your trial ends</p>
      <p className="mt-1 text-xs text-slate-400">Charged in Ghana cedis (GHS) through Paystack.</p>
    </div>
  );
};
